import { render } from "./AppFooter.vue?vue&type=template&id=4029c284"
const script = {}

import exportComponent from "F:\\codecanyon-work\\demo-page\\NAC-Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__